import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SMARTBNB_API_V1 } from '@core';
import { Owner } from '../../interfaces/business.interface';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  // Dependencies
  private readonly smartbnbApiV1: string = inject(SMARTBNB_API_V1);
  private readonly http = inject(HttpClient);

  #statementsApiBase = `${this.smartbnbApiV1}/operations/v2`;

  getOwner(id: Owner['id']) {
    return this.http.get<Owner>(`${this.#statementsApiBase}/owners/${id}`);
  }
}
